module.exports = __webpack_public_path__ + "media/images/edion/top/6-ebf8ad22efde987b0b0f5060c56e2b27.png";